
.cropArea {
    composes: defaults from "printout.module.css";
    page-break-inside: avoid;
    /* A4 portrait */
    width: 210mm;
    height: 297mm;
    /* enable the children to fill all space */
    display: flex;
    /* add print preview markers */
    outline: 1px solid lightgray;
    margin-bottom: 8px;
}

@media print {
    .cropArea {
        /* remove print preview markers */
        outline: none;
        margin: 0;
    }
}
